<div class="row align-items-center">
  <div class="col">

    <!-- Form -->
    <form>
      <div class="input-group input-group-flush input-group-merge input-group-reverse">
        <input (ngModelChange)="searchTextUpdated($event)" [ngModel]="searchTableViewModel.searchText"
          [placeholder]="searchFieldPlaceholderText"
          class="form-control list-search" type="search">
        <span class="input-group-text">
          <i class="fe fe-search"></i>
        </span>
      </div>
    </form>

  </div>
  <div class="col-auto me-n3">

    <!-- Select -->
    <form>
      <select (ngModelChange)="numberOfResultsPerPageUpdated($event)"
        [ngModel]="searchTableViewModel.numberOfResultsPerPage"
        class="form-select form-select-sm form-control-flush">
        @for (numberOfResultsPerPage of numberOfResultsPerPageChoices; track numberOfResultsPerPage) {
          <option
            [value]="numberOfResultsPerPage">{{ numberOfResultsPerPage }} {{ perPageLabelText }}
          </option>
        }
      </select>
    </form>

  </div>
  <!--    <div class="col-auto">-->

  <!--        &lt;!&ndash; Dropdown &ndash;&gt;-->
  <!--        <div class="dropdown">-->

  <!--            &lt;!&ndash; Toggle &ndash;&gt;-->
  <!--            <button class="btn btn-sm btn-white" type="button" data-bs-toggle="dropdown"-->
  <!--                    data-bs-auto-close="outside" aria-haspopup="true" aria-expanded="false">-->
  <!--                <i class="fe fe-sliders me-1"></i> Filter <span-->
<!--                    class="badge bg-primary ms-1 d-none">0</span>-->
<!--            </button>-->

<!--            &lt;!&ndash; Menu &ndash;&gt;-->
<!--            <form class="dropdown-menu dropdown-menu-end dropdown-menu-card">-->
<!--                <div class="card-header">-->

<!--                    &lt;!&ndash; Title &ndash;&gt;-->
<!--                    <h4 class="card-header-title">-->
<!--                        Filters-->
<!--                    </h4>-->

<!--                    &lt;!&ndash; Link &ndash;&gt;-->
<!--                    <button class="btn btn-sm btn-link text-reset d-none" type="reset">-->
<!--                        <small>Clear filters</small>-->
<!--                    </button>-->

<!--                </div>-->
<!--                <div class="card-body">-->

<!--                    &lt;!&ndash; List group &ndash;&gt;-->
<!--                    <div class="list-group list-group-flush mt-n4 mb-4">-->
<!--                        <div class="list-group-item">-->
<!--                            <div class="row">-->
<!--                                <div class="col">-->

<!--                                    &lt;!&ndash; Text &ndash;&gt;-->
<!--                                    <small>Title</small>-->

<!--                                </div>-->
<!--                                <div class="col-auto">-->

<!--                                    &lt;!&ndash; Select &ndash;&gt;-->
<!--                                    <select class="form-select form-select-sm" name="item-title"-->
<!--                                            data-choices='{"searchEnabled": false}'>-->
<!--                                        <option value="*" selected>Any</option>-->
<!--                                        <option value="Designer">Designer</option>-->
<!--                                        <option value="Developer">Developer</option>-->
<!--                                        <option value="Owner">Owner</option>-->
<!--                                        <option value="Founder">Founder</option>-->
<!--                                    </select>-->

<!--                                </div>-->
<!--                            </div> &lt;!&ndash; / .row &ndash;&gt;-->
<!--                        </div>-->
<!--                        <div class="list-group-item">-->
<!--                            <div class="row">-->
<!--                                <div class="col">-->

<!--                                    &lt;!&ndash; Text &ndash;&gt;-->
<!--                                    <small>Lead scrore</small>-->

<!--                                </div>-->
<!--                                <div class="col-auto">-->

<!--                                    &lt;!&ndash; Select &ndash;&gt;-->
<!--                                    <select class="form-select form-select-sm" name="item-score"-->
<!--                                            data-choices='{"searchEnabled": false}'>-->
<!--                                        <option value="*" selected>Any</option>-->
<!--                                        <option value="1/10">1+</option>-->
<!--                                        <option value="2/10">2+</option>-->
<!--                                        <option value="3/10">3+</option>-->
<!--                                        <option value="4/10">4+</option>-->
<!--                                        <option value="5/10">5+</option>-->
<!--                                        <option value="6/10">6+</option>-->
<!--                                        <option value="7/10">7+</option>-->
<!--                                        <option value="8/10">8+</option>-->
<!--                                        <option value="9/10">9+</option>-->
<!--                                        <option value="10/10">10</option>-->
<!--                                    </select>-->

<!--                                </div>-->
<!--                            </div> &lt;!&ndash; / .row &ndash;&gt;-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    &lt;!&ndash; Button &ndash;&gt;-->
<!--                    <button class="btn w-100 btn-primary" type="submit">-->
<!--                        Apply filter-->
<!--                    </button>-->

<!--                </div>-->
<!--            </form>-->

<!--        </div>-->

<!--    </div>-->
</div> <!-- / .row -->
